import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/no-results.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "results-icon",
  alt: "No results icon"
}, null, -1)
const _hoisted_2 = { class: "results-title" }
const _hoisted_3 = { class: "results-info" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = {
  href: "https://uoguelph.eu.qualtrics.com/jfe/form/SV_3QSa6nuyjLlTdI2?Q_PopulateResponse=%7B\"QID9\":\"1\",\"QID4\":\"10\",\"QID11\":\"2\"%7D&Q_lang=en-ca&Source=Context-Explorer",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
            'no-results-content-small': !_ctx.fullLength,
            'no-results-content-big': _ctx.fullLength,
        })
  }, [
    _hoisted_1,
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("NoResults.results_title")), 1),
    _createElementVNode("p", _hoisted_3, [
      _createTextVNode(_toDisplayString(_ctx.$t("NoResults.results_info")) + " ", 1),
      _hoisted_4,
      _hoisted_5,
      _createTextVNode(" " + _toDisplayString(_ctx.$t("NoResults.results_error")) + " ", 1),
      _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$t("NoResults.feedback_form")), 1),
      _createTextVNode(". ")
    ])
  ], 2))
}